<template>
  <div></div>
</template>

<script>
import helpers from "@/helpers"
import { baseApiUrl } from "@/global"
import axios from "axios"
import xlsx from "xlsx"

export default {
  data() {
    return {
      data: [],
      orders: []
    }
  },
  methods: {
    async generate(filters) {
      this.orders = []
      this.filters = filters
      this.helpers = helpers

      await this.getOrders()
      this.fixVarsToTable()
      if (!this.orders.length) return false
      this.makeXLSX()
      return true
    },
    async getOrders() {
      try {
        this.$vs.loading()
        const response = await axios.post(`${baseApiUrl}/report/saleReport`, {
          representante: this.filters.representante,
          orderBy: this.filters.orderBy.code
        })
        this.data = response.data
      } catch (error) {
        this.$vs.notify({
          title: 'Erro',
          text: error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      } finally {
        this.$vs.loading.close()
      }
    },
    fixVarsToTable() {
      for (const index in this.data) {
        const order = this.data[index]
        this.orders.push({
          "Cliente": order.cliente,
          "Representante": order.representante,
          // "Primeira Compra": this.helpers.dateHelper.formatDateToPTBR(order.primeiraCompra),
          "Ult. Compra Regnaparts": this.helpers.dateHelper.formatDateToPTBR(order.ultimaCompraRegnaparts),
          "Ult. Compra Revestebem": this.helpers.dateHelper.formatDateToPTBR(order.ultimaCompraRevestebem),
          "Vlr. Últ. Regnaparts": this.helpers.moneyHelper.formatNumberToCurrency(order.valorUltimaCompraRegnaparts),
          "Vlr. Últ. Revestebem": this.helpers.moneyHelper.formatNumberToCurrency(order.valorUltimaCompraRevestebem),
          "Valor Total": this.helpers.moneyHelper.formatNumberToCurrency(order.valorTotal),
          "Número de Pedidos": order.numeroPedidos,
        })
      }
    },
    XLSXfitColumns(json, worksheet) {
      const jsonKeys = Object.keys(json[0]);

      let objectMaxLength = [];
      for (let i = 0; i < json.length; i++) {
        let value = json[i];
        for (let j = 0; j < jsonKeys.length; j++) {
          if (typeof value[jsonKeys[j]] == "number") {
            objectMaxLength[j] = 10;
          } else {

            const l = value[jsonKeys[j]] ? value[jsonKeys[j]].length : 0;

            objectMaxLength[j] =
              objectMaxLength[j] >= l ?
              objectMaxLength[j] :
              l;
          }
        }

        let key = jsonKeys;
        for (let j = 0; j < key.length; j++) {
          objectMaxLength[j] =
            objectMaxLength[j] >= key[j].length ?
            objectMaxLength[j] :
            key[j].length;
        }
      }
      const wscols = objectMaxLength.map(w => { return { width: w + 5 } });
      worksheet["!cols"] = wscols
    },
    makeXLSX() {
      const worksheet = xlsx.utils.json_to_sheet(this.orders)
      this.XLSXfitColumns(this.orders, worksheet)
      const workbook = xlsx.utils.book_new()
      xlsx.utils.book_append_sheet(workbook, worksheet, 'Planilha 1')
      xlsx.writeFile(workbook, 'Relatorio_Vendas.xlsx')
    }
  }
}

</script>
